export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9404.8d67b36e.jpg";